import { Link } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    border: solid 1px #ba3e21;
    background-color: #fff8f7;
    display: flex;
    margin-top: 30px;
    align-items: center;
`;

export const ImageWrapper = styled.div`
    margin: 0 10px;
`;

export const TextWrapper = styled.div`
    margin: 10px 20px 10px 10px;
`;

export const StyledLink = styled(Link)`
    font-weight: 600;
`;
